import React, { createContext, useState } from "react";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import AI from "../../../domain/models/AI";
import getAIBySubscriptionId from "../../../domain/use_cases/ai/getAIBySubscriptionId";

const AIContext = createContext({
  item: null as AI | null,
  status: ContextStatus.IDLE,
  fetch: (_: string) => new Promise<void>((resolve, reject) => null),
  reset: () => {return;},
});

export const AIProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [item, setItem] = useState(null as AI | null);

  const [status, setStatus] = useState(ContextStatus.IDLE);

  const fetch = async (subscriptionId: string) => {
    setStatus(ContextStatus.LOADING);
    try {
      const useCaseResponse = await getAIBySubscriptionId(subscriptionId);
      if (useCaseResponse) {
        setItem(useCaseResponse);
        setStatus(ContextStatus.SUCCESS);
      } else {
        setStatus(ContextStatus.ERROR);
      }
      setStatus(ContextStatus.SUCCESS);
    } catch (e) {
      setStatus(ContextStatus.ERROR);
    }
  };

  const reset = () => {
    setItem(null);
    setStatus(ContextStatus.IDLE);
  };

  return (
    <AIContext.Provider
      value={{
        item,
        status,
        fetch,
        reset,
      }}
    >
      {children}
    </AIContext.Provider>
  );
};

export default AIContext;
